import { TSheetFolder } from "../../../../../DataDrive"
import { useOutletContext } from "react-router"

export default function useFolderDetailsOutletContext() {
	const { folderDetails, refreshFolderDetails } = useOutletContext<{
		folderDetails: TSheetFolder
		refreshFolderDetails: () => void
	}>()
	return { folderDetails, refreshFolderDetails }
}
